module.exports = __webpack_public_path__ + "img/Weapon_208.334e06db.png";